<script setup lang="ts">
import { RouterView, useRoute } from "vue-router";
import { computed } from "vue";
import Header from "./views/Header/Header.vue";
import { useAuthStore } from "./stores/auth";

const authStore = useAuthStore();
const route = useRoute();

// Only show header if authenticated AND not on login page
const shouldShowHeader = computed(() => {
  return authStore.isAuthenticated && route.path !== "/login";
});
</script>

<template>
  <div class="flex flex-col h-full">
    <Header v-if="shouldShowHeader" class="flex-shrink-0" />
    <main class="flex-1 overflow-y-auto overflow-x-hidden">
      <div class="w-full h-full p-4">
        <RouterView />
      </div>
    </main>
  </div>
</template>
